import { render, staticRenderFns } from "./ReviewBoosterTagItem.vue?vue&type=template&id=73e9221d&scoped=true&"
import script from "./ReviewBoosterTagItem.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterTagItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterTagItem.vue?vue&type=style&index=0&id=73e9221d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e9221d",
  null
  
)

export default component.exports